export default "__VITE_ASSET__4d479b8f__"